import { Box, Typography } from '@material-ui/core'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import moment from 'moment-timezone'
import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import React, { useEffect, useRef, useState } from 'react'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import Namespace from 'src/constants/locale/Namespace'
import Table from '../../../components/aciacehighway/Table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import pathMap from 'src/paths/pathMap'
import ConfirmDialog from 'src/views/common/ConfirmDialog'

const {
  table: {
    useFetchCodeMaintenanceLookup
  },
} = components

const {
  filter: { EQUAL, IN, LIKE }
} = constants

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const { history, location, showNotification } = props
  const tableRef = useRef(null)
  const { securedSendRequest } = useServices()
  const { translate } = useTranslation([Namespace.UI_COMPONENT, Namespace.UAE_MPCI])

  const [confirmDialog, setConfirmDialog] = useState({ open: false, manifest: null })

  const title = translate(Namespace.UAE_MPCI, UaeMpciKeys.TITLE)
  const billNo = translate(Namespace.UAE_MPCI, UaeMpciKeys.BILL_NO)
  const parentBillNo = translate(Namespace.UAE_MPCI, UaeMpciKeys.PARENT_BILL_NO)
  const functionType = translate(Namespace.UAE_MPCI, UaeMpciKeys.FUNCTION_TYPE)
  const shipmentType = translate(Namespace.UAE_MPCI, UaeMpciKeys.SHIPMENT_TYPE)
  const status = translate(Namespace.UAE_MPCI, UaeMpciKeys.STATUS)
  const createdDate = translate(Namespace.UAE_MPCI, UaeMpciKeys.CREATED_DATE)
  const documentType = translate(Namespace.UAE_MPCI, UaeMpciKeys.DOCUMENT_TYPE)
  const editButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.EDIT_BUTTON)
  const deleteButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.DELETE_BUTTON)
  const createButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.CREATE_BUTTON)
  const deleteWarningMessage = translate(Namespace.UAE_MPCI, UaeMpciKeys.DELETE_WARNING_MESSAGE)
  const okDeleteButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.OK_DELETE_BUTTON)
  const cancelDeleteButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.CANCEL_DELETE_BUTTON)

  function handleDeleteManifest() {
    if (confirmDialog.manifest) {
      securedSendRequest.execute(
        'DELETE',
        UaeMpciApiUrls.DELETE,
        confirmDialog.manifest,
        (response) => {
          if (response.status === 200) {
            showNotification('success', 'Delete succeeded')
            setConfirmDialog({ open: false, manifest: null })
            tableRef.current.performRefresh()
          }
        },
        (error) => {
          console.log(error)
          showNotification('error', 'Delete failed')
        }
      )
    }
  }

    const columns = [
    { field: 'billNo', title: billNo },
    { field: 'parentBillNo', title: parentBillNo },
    { field: 'documentType', title: documentType },
    { field: 'functionType', title: functionType },
    { field: 'shipmentType', title: shipmentType },
    { field: 'status', title: status },
    {
      field: 'createdDate',
      title: createdDate,
      render: (data) => data.createdDate && moment(data.createdDate).format('D MMM YYYY, HH:mm')
    }
  ]

  const filters = [
    { name: 'billNo', label: billNo, type: 'textfield', operatorType: LIKE },
    { name: 'parentBillNo', label: parentBillNo, type: 'textfield', operatorType: LIKE },
    { name: 'functionType', label: functionType, type: 'textfield', operatorType: LIKE },
    { name: 'shipmentType', label: shipmentType, type: 'textfield', operatorType: LIKE },
    { name: 'createdDate', label: createdDate, type: 'daterange', operatorType: LIKE }
  ]

  return (
    <>
      <Table
        actions={[
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.UAE_MPCI_ADD_VIEW)
            },
            label: createButton
          }
        ]}
        columns={columns}
        compact
        fetch={{ url: UaeMpciApiUrls.GET }}
        fetchFilters={[
          { field: 'partyId', operator: IN, value: FileForUserGetPartyId() }
        ]}
        filters={filters}
        onRowClick={(rowData) => history.push(`${location.pathname}/edit/${rowData.id}`)}
        rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: editButton,
            onClick: (rowData) => history.push(`${location.pathname}/edit/${rowData.id}`)
          },
          {
            label: deleteButton,
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            onClick: (data) => setConfirmDialog({ open: true, manifest: data })
          }
        ]}
        showNotification={showNotification}
        
        persistSettings
        tableRef={tableRef}
      />
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog.open}
        closeDialog={() => setConfirmDialog({ open: false, manifest: null })}
        confirmDialog={handleDeleteManifest}
        content={deleteWarningMessage}
        okMsg={okDeleteButton}
        cancelMsg={cancelDeleteButton}
        title={deleteButton}
      />
    </>
  )
}

export default TablePage
